module.exports = __webpack_public_path__ + "static/img/redeemed.6a5b7c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/DailyTask/img/slider/redeemed.png
// module id = 499
// module chunks = 0